// Default number of rows per page on initial table load
export const DEFAULT_TABLE_PAGE_SIZE = 25;

// Available page size options in the dropdown
export const TABLE_PAGE_SIZE_OPTIONS = [5, 10, 25, 50] as const;
